// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Emitter$LiveRoom from "../bindings/Emitter.bs.js";

var serverTime = {
  contents: undefined
};

var serverTimeId = {
  contents: undefined
};

var Emitter = Emitter$LiveRoom.CreateEmitter({});

function setServerTime(newTime) {
  var timerId = serverTimeId.contents;
  if (timerId !== undefined) {
    clearInterval(Caml_option.valFromOption(timerId));
  }
  serverTime.contents = newTime;
  var timerId$1 = setInterval((function (param) {
          serverTime.contents = Belt_Option.getExn(serverTime.contents) + 1000.0;
          Curry._1(Emitter.emit, /* ServerTime */{
                _0: serverTime.contents
              });
        }), 1000);
  serverTime.contents = newTime;
  serverTimeId.contents = Caml_option.some(timerId$1);
  Curry._1(Emitter.emit, /* ServerTime */{
        _0: serverTime.contents
      });
}

function getServerTime(param) {
  var t = serverTime.contents;
  if (t !== undefined) {
    return t;
  } else {
    return Date.now();
  }
}

export {
  serverTime ,
  serverTimeId ,
  Emitter ,
  setServerTime ,
  getServerTime ,
}
/* Emitter Not a pure module */
